import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Card, CardContent, Icon, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import routes from './routes';
import WorkIcon from '@mui/icons-material/Work';
import CodeIcon from '@mui/icons-material/Code';
import BrushIcon from '@mui/icons-material/Brush';
import BusinessIcon from '@mui/icons-material/Business';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CreateIcon from '@mui/icons-material/Create';
import PrimaryButton from './components/PrimaryButton';
import { auth } from './firebaseConfig';

const professions = [
  { value: 'software_developer', label: 'Desenvolvedor de Software', icon: <CodeIcon /> },
  { value: 'designer', label: 'Designer', icon: <BrushIcon /> },
  { value: 'consultant', label: 'Consultor', icon: <BusinessIcon /> },
  { value: 'photographer', label: 'Fotógrafo', icon: <CameraAltIcon /> },
  { value: 'writer', label: 'Redator', icon: <CreateIcon /> },
  { value: 'other', label: 'Outra profissão', icon: <WorkIcon /> },
];

const SelectProfession = () => {
  const [selectedProfession, setSelectedProfession] = useState('');
  const [customProfession, setCustomProfession] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      navigate(routes.HOME);
    }
  }, [navigate]);

  const handleNext = () => {
    const profession =
      selectedProfession === 'other' ? customProfession : selectedProfession;
    console.log('Profissão selecionada:', profession);

    // Lógica para passar para a próxima etapa
    navigate(routes.CREATE_CONTRACT, { state: { profession } });
  };

  return (
    <Box sx={{ padding: 3, maxWidth: 800, margin: '0 auto' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Selecionar profissão
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Escolha uma profissão para personalizar seu contrato.
      </Typography>
      <Grid container spacing={2}>
        {professions.map((option) => (
          <Grid item xs={12} sm={6} key={option.value}>
            <Card
              onClick={() => setSelectedProfession(option.value)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: 2,
                borderRadius: 2,
                cursor: 'pointer',
                border: selectedProfession === option.value ? '2px solid #1976d2' : '1px solid #ccc',
                boxShadow: selectedProfession === option.value ? 3 : 1,
                transition: 'border 0.3s, box-shadow 0.3s',
                height: '100%',
              }}
            >
              <CardContent sx={{ display: 'flex', width: '100%' }}>
                <Icon sx={{ marginRight: 2 }}>
                  {option.icon}
                </Icon>
                <Typography variant="subtitle1">{option.label}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {selectedProfession === 'other' && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Digite sua profissão
          </Typography>
          <TextField
            value={customProfession}
            onChange={(e) => setCustomProfession(e.target.value)}
            fullWidth
          />
        </Box>
      )}
      <PrimaryButton
        fullWidth
        onClick={handleNext}
        disabled={!selectedProfession || (selectedProfession === 'other' && !customProfession)}
        sx={{ mt: 3 }}
      >
        Continuar
      </PrimaryButton>
    </Box>
  );
};

export default SelectProfession;